import { render, staticRenderFns } from "./InfosMonte.vue?vue&type=template&id=213d4fdc&"
import script from "./InfosMonte.vue?vue&type=script&lang=js&"
export * from "./InfosMonte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports